/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {ICONS} from "@res/icons";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {Route_Alerts, Route_Base, Route_Default} from "../../Routes";
import {AlertsModule, OnAlertsUpdated} from "@modules/AlertsModule";
import {LeftPanelSection} from "./LeftPanelSection";
import {PatientContextProvider} from "./patients/PatientsContext";
import {OrgRoleLevel} from "@app/app-shared/permission";

export class AlertsPanel
    extends BaseComponent<{}> implements OnAlertsUpdated {

    __onAlertsUpdated = () => this.forceUpdate();

    render() {
        return <PatientContextProvider roles={[OrgRoleLevel.USER_DATA]}>{
            ({patients, demo}) => {
                return <LeftPanelSection
                    icon={ICONS.icon_alert}
                    routeKeys={[Route_Base, Route_Alerts, Route_Default]}
                    title={"Notifications"}
                    showDot={demo ? false : AlertsModule.existsUnresolvedAlert(patients)}/>
            }
        }</PatientContextProvider>
    }
}
